import { render, staticRenderFns } from "./IndexDash.vue?vue&type=template&id=8b432f94&scoped=true"
import script from "./IndexDash.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IndexDash.vue?vue&type=style&index=0&id=8b432f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b432f94",
  null
  
)

export default component.exports